function Footer() {
  return (
    <footer className="bg-gray-900 text-white text-center py-5">
      <p className="text-sm">
        React Learning Journey © 2026
      </p>
    </footer>
  );
}

export default Footer;